
import React from "react";
import { useIsMobile } from "@/hooks/use-mobile";

interface CategoryFilterProps {
  categories: string[];
  selectedCategory: string | null;
  onCategoryChange: (category: string | null) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  selectedCategory,
  onCategoryChange,
}) => {
  const isMobile = useIsMobile();
  
  // Si aucune catégorie n'est disponible, ne pas afficher le filtre
  if (!categories || categories.length === 0) {
    console.log("Aucune catégorie à afficher, le filtre ne sera pas rendu");
    return null;
  }
  
  // Définir l'ordre personnalisé des catégories
  const categoryOrder = ["Hommes", "Femmes", "Enfants", "Vêtements de travail", "Accessoires"];
  
  // Trier les catégories selon l'ordre personnalisé
  const sortedCategories = [...categories].sort((a, b) => {
    const indexA = categoryOrder.indexOf(a);
    const indexB = categoryOrder.indexOf(b);
    
    // Si une catégorie n'est pas dans la liste d'ordre, la placer à la fin
    if (indexA === -1 && indexB === -1) return a.localeCompare(b);
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;
    
    // Sinon, trier selon l'ordre défini
    return indexA - indexB;
  });

  return (
    <div className={`flex justify-center ${isMobile ? 'flex-wrap gap-2 px-1 py-4' : 'gap-4 flex-wrap py-6'}`}>
      {sortedCategories.map((category) => (
        <button
          key={category}
          onClick={() => {
            console.log(`Setting category filter: ${category}`);
            onCategoryChange(category);
          }}
          className={`px-3 py-1.5 md:px-4 md:py-2 text-sm md:text-base rounded-full transition-colors ${
            selectedCategory === category
              ? "bg-primary text-white"
              : "bg-gray-100 hover:bg-gray-200"
          }`}
        >
          {category}
        </button>
      ))}
      <button
        onClick={() => {
          console.log("Clearing category filter");
          onCategoryChange(null);
        }}
        className={`px-3 py-1.5 md:px-4 md:py-2 text-sm md:text-base rounded-full transition-colors ${
          !selectedCategory
            ? "bg-primary text-white"
            : "bg-gray-100 hover:bg-gray-200"
        }`}
      >
        Tous
      </button>
    </div>
  );
};

export default CategoryFilter;
